import React from 'react';
import { useBoolean } from 'react-hanger';
import CoreSplitter from '@components-clean/core/core-splitter';
import Toggle from '@components-clean/core/toggle';
import { SplitterOrientation } from '@utils/constants';

const SplitterPage = () => {
    const horizontalOrientation = useBoolean(true);

    return (
        <div style={{ height: 'calc(100vh - 300px)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '20px' }}>
                <p>Set Horizontal Orientation</p>
                <Toggle
                    defaultChecked
                    value={horizontalOrientation.value}
                    data-testid="example-toggle"
                    onChange={() => horizontalOrientation.toggle()}
                />
            </div>
            <CoreSplitter
                className="!k-h-full"
                orientation={
                    horizontalOrientation.value ? SplitterOrientation.horizontal : SplitterOrientation.vertical
                }
                alignmentValues={[
                    {
                        size: '20%',
                        min: '20px',
                    },
                    {},
                    {
                        size: '30%',
                        min: '20px',
                    },
                ]}
                data-testid="test-splitter"
            >
                <div data-testid="one-pane" className="k-p-1.5">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam id augue lorem. Nulla a dui eget
                    massa volutpat auctor. Mauris eget bibendum ante, vitae venenatis nulla. Interdum et malesuada fames
                    ac ante ipsum primis in faucibus. Suspendisse potenti. Lorem ipsum dolor sit amet, consectetur
                    adipiscing elit. Donec pulvinar nulla ex, ac pharetra elit facilisis nec. Aliquam eget turpis
                    turpis. Nunc gravida eleifend ante, eu molestie erat tempus nec.
                </div>
                <div data-testid="two-pane" className="k-p-1.5">
                    Duis fermentum rutrum fringilla. Donec quis orci sit amet ex elementum lacinia. Suspendisse bibendum
                    lectus tincidunt efficitur mattis. Praesent tincidunt sapien ante. Mauris quis quam arcu. Curabitur
                    eu cursus nisl, sit amet pharetra massa. In imperdiet diam id purus maximus interdum id in nisl.
                    Curabitur porta neque ut augue pretium bibendum. Orci varius natoque penatibus et magnis dis
                    parturient montes, nascetur ridiculus mus. Phasellus ut condimentum leo. Nulla in ipsum id lacus
                    lobortis ultricies. Sed consectetur leo in lectus finibus laoreet vitae nec massa.
                </div>
                <div data-testid="three-pane" className="k-p-1.5">
                    Duis fermentum rutrum fringilla. Donec quis orci sit amet ex elementum lacinia. Suspendisse bibendum
                    lectus tincidunt efficitur mattis. Praesent tincidunt sapien ante. Mauris quis quam arcu. Curabitur
                    eu cursus nisl, sit amet pharetra massa. In imperdiet diam id purus maximus interdum id in nisl.
                    Curabitur porta neque ut augue pretium bibendum. Orci varius natoque penatibus et magnis dis
                    parturient montes, nascetur ridiculus mus. Phasellus ut condimentum leo. Nulla in ipsum id lacus
                    lobortis ultricies. Sed consectetur leo in lectus finibus laoreet vitae nec massa.
                </div>
            </CoreSplitter>
        </div>
    );
};

export default SplitterPage;
